"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Spaces = /*#__PURE__*/ _interop_require_default(require("./Spaces"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SpacesPlugin = class SpacesPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return SpacesPlugin.storageAdapter;
    }
    async init(config) {
        SpacesPlugin.storageAdapter = new _Spaces.default(config);
        await SpacesPlugin.storageAdapter.init();
    }
};
const _default = SpacesPlugin;
